<template>
    <ModalBase @close="cancel" :withContent="true">
        <main>
            <h1>{{ $t("plano.confirmExit.title", { name }) }}</h1>
            <p>{{ $t("plano.confirmExit.message", { name }) }}</p>
            <button class="btn" @click="save(false);">{{ $t("plano.confirmExit.dontSaveButton") }}</button>
            <button class="btn" @click="cancel();">{{ $t("plano.confirmExit.cancelButton") }}</button>
            <button class="btn saveButton" @click="save(true);">{{ saveButtonText }}</button>
        </main>
    </ModalBase>
</template>

<script>
import ModalBase from "@/components/modal/ModalBase";
export default {
    name: "ModalExit",
    props: {
        name: { type: String },
        readOnly: { type: Boolean }
    },
    components: {
        ModalBase
    },
    methods: {
        cancel() {
            this.$emit("close");
        },
        save(bool) {
            this.$emit("save", bool);
        }
    },
    computed: {
        saveButtonText() {
            return !this.readOnly ? this.$t("plano.confirmExit.saveButton") : this.$t("common.saveAs");
        }
    }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/themes";
main {
    text-align: center;
    h1 {
        font-size: 20px;
    }
    .btn {
        display: inline-block;
        font-size: 16px;
        margin: 0px 10px;
        &.saveButton {
            background-color: $color2;
            border-color: $color2;
        }
    }
}
</style>



// WEBPACK FOOTER //
// ModalExitPlano.vue?25fd95ee